import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, Unsubscribe } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBQX40JEEnd6uXl2KkOEJ0YLDiWCD7A-sQ",
  authDomain: "yodel-app-2020.firebaseapp.com",
  projectId: "yodel-app-2020",
  storageBucket: "yodel-app-2020.firebasestorage.app",
  messagingSenderId: "1020939902415",
  appId: "1:1020939902415:web:d871ff68887392a30006ba",
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const requestFirebaseNotificationPermission = async () => {
  try {
    const vapidKey = "BDi8JIlHJ9NM8-NDfQoC_FWEO1RoqdQKCblZHouO7J6xAZ_A9ifUPbeoRB6cG9Xi0gj9hQOF9fUb4xMRzwTZwqY"; // FROM Firebase console
    const token = await getToken(messaging, { vapidKey });
    return token;
  } catch (err) {
    console.error("Notification permission error", err);
    return null;
  }
};

// export const onMessageListener = () =>
//   new Promise((resolve) => {
//     onMessage(messaging, (payload) => resolve(payload));
//   });

export const onMessageListener = (callback: (payload: any) => void): Unsubscribe => {
    return onMessage(messaging, callback);
};
